import React, { useEffect, useState } from "react"

import {
    Card,
    CardBody,
    Col,
    Row,
    CardTitle,
} from "reactstrap"

import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import Loader from "components/Loader/Loader";
import { toast } from "react-toastify";
import { createCategory } from "helpers/category_helper";
import TCalendar from "./components/TCalendar";


const TrainingCalendar = (props) => {
    document.title = "Training Management | Training Calendar";




    const breadcrumbItems = [
        { title: "Training", link: "#" },
        { title: "Training Calendar", link: "#" },
    ]
    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])
    useEffect(() => {
        props.setBreadcrumbItems('Training Calendar', breadcrumbItems)
    })

    const [loader, setLoader] = useState(false);





    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row >
                <TCalendar loader={loader} setLoader={setLoader} />
            </Row>



        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(TrainingCalendar);